const { default: styled } = require("styled-components");

const NoDataInTableWrapper = styled.section`
  padding: 5rem 0rem;
  width: 100%;
`;
export default NoDataInTableWrapper;
